import { useState } from "react";
import "./editorialForms.css";

export default function EstudentForm({ data, onChange }) {
  const [resourceInput, setResourceInput] = useState("");

  const contentTypes = [
    { id: "notes", name: "Anotações" },
    { id: "summary", name: "Resumo" },
    { id: "flashcards", name: "Flashcards" },
    { id: "mindmap", name: "Mapa Mental" },
    { id: "exercise", name: "Exercícios" },
    { id: "exam", name: "Prova/Simulado" },
    { id: "presentation", name: "Apresentação" },
    { id: "project", name: "Projeto" },
  ];

  const subjects = [
    "Matemática",
    "Português",
    "História",
    "Geografia",
    "Ciências",
    "Física",
    "Química",
    "Biologia",
    "Inglês",
    "Espanhol",
    "Filosofia",
    "Sociologia",
    "Artes",
    "Educação Física",
    "Programação",
    "Outro",
  ];

  const educationLevels = [
    { id: "fundamental", name: "Ensino Fundamental" },
    { id: "medio", name: "Ensino Médio" },
    { id: "tecnico", name: "Ensino Técnico" },
    { id: "graduacao", name: "Graduação" },
    { id: "pos", name: "Pós-graduação" },
    { id: "concurso", name: "Concursos" },
    { id: "vestibular", name: "Vestibular/ENEM" },
  ];

  const handleAddResource = () => {
    if (resourceInput.trim()) {
      onChange({
        ...data,
        resources: [...(data?.resources || []), resourceInput.trim()],
      });
      setResourceInput("");
    }
  };

  const handleRemoveResource = (index) => {
    onChange({
      ...data,
      resources: (data?.resources || []).filter((_, i) => i !== index),
    });
  };

  return (
    <div className="editorial_form estudent_form">
      <div className="editorial_form_section">
        <label>
          Título do Material <span className="required">*</span>
        </label>
        <input
          type="text"
          placeholder="Ex: Resumo de Trigonometria"
          value={data?.title || ""}
          onChange={(e) => onChange({ ...data, title: e.target.value })}
        />
      </div>

      <div className="editorial_form_section">
        <label>Descrição</label>
        <textarea
          placeholder="Descreva o conteúdo do material..."
          value={data?.description || ""}
          onChange={(e) => onChange({ ...data, description: e.target.value })}
          maxLength={1000}
          rows={3}
        />
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>Tipo de Conteúdo</label>
          <select
            value={data?.contentType || "notes"}
            onChange={(e) => onChange({ ...data, contentType: e.target.value })}
          >
            {contentTypes.map((type) => (
              <option key={type.id} value={type.id}>
                {type.name}
              </option>
            ))}
          </select>
        </div>

        <div className="editorial_form_section">
          <label>Matéria</label>
          <select
            value={data?.subject || ""}
            onChange={(e) => onChange({ ...data, subject: e.target.value })}
          >
            <option value="">Selecione</option>
            {subjects.map((sub) => (
              <option key={sub} value={sub}>
                {sub}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>Nível de Ensino</label>
          <select
            value={data?.educationLevel || ""}
            onChange={(e) => onChange({ ...data, educationLevel: e.target.value })}
          >
            <option value="">Selecione</option>
            {educationLevels.map((level) => (
              <option key={level.id} value={level.id}>
                {level.name}
              </option>
            ))}
          </select>
        </div>

        <div className="editorial_form_section">
          <label>Tópico/Capítulo</label>
          <input
            type="text"
            placeholder="Ex: Capítulo 5 - Funções"
            value={data?.topic || ""}
            onChange={(e) => onChange({ ...data, topic: e.target.value })}
          />
        </div>
      </div>

      <div className="editorial_form_section">
        <label>Instituição/Curso</label>
        <input
          type="text"
          placeholder="Ex: USP - Engenharia de Computação"
          value={data?.institution || ""}
          onChange={(e) => onChange({ ...data, institution: e.target.value })}
        />
      </div>

      <div className="editorial_form_section">
        <label>
          Recursos Adicionais
          <button
            type="button"
            className="add_variant_btn"
            onClick={handleAddResource}
          >
            + Adicionar
          </button>
        </label>
        <input
          type="text"
          placeholder="Link ou nome do recurso..."
          value={resourceInput}
          onChange={(e) => setResourceInput(e.target.value)}
          onKeyPress={(e) => e.key === "Enter" && handleAddResource()}
        />
        <div className="genre_chips" style={{ marginTop: "8px" }}>
          {(data?.resources || []).map((res, i) => (
            <span
              key={i}
              className="genre_chip selected"
              onClick={() => handleRemoveResource(i)}
              style={{ cursor: "pointer" }}
            >
              {res} ×
            </span>
          ))}
        </div>
      </div>

      <div className="editorial_form_section">
        <label>Configurações</label>
        <div className="editorial_form_checkboxes">
          <div className="editorial_form_checkbox">
            <input
              type="checkbox"
              id="allowDownload"
              checked={data?.allowDownload !== false}
              onChange={(e) =>
                onChange({ ...data, allowDownload: e.target.checked })
              }
            />
            <label htmlFor="allowDownload">Permitir download</label>
          </div>
          <div className="editorial_form_checkbox">
            <input
              type="checkbox"
              id="allowComments"
              checked={data?.allowComments !== false}
              onChange={(e) =>
                onChange({ ...data, allowComments: e.target.checked })
              }
            />
            <label htmlFor="allowComments">Permitir comentários</label>
          </div>
          <div className="editorial_form_checkbox">
            <input
              type="checkbox"
              id="isVerified"
              checked={data?.isVerified || false}
              onChange={(e) =>
                onChange({ ...data, isVerified: e.target.checked })
              }
            />
            <label htmlFor="isVerified">Material verificado por professor</label>
          </div>
        </div>
      </div>

      <div className="editorial_form_tip estudent_tip">
        <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
          <path d="M12 3L1 9l4 2.18v6L12 21l7-3.82v-6l2-1.09V17h2V9L12 3zm6.82 6L12 12.72 5.18 9 12 5.28 18.82 9zM17 15.99l-5 2.73-5-2.73v-3.72L12 15l5-2.73v3.72z" />
        </svg>
        <span>
          Compartilhe materiais de estudo com outros estudantes. Organize por
          matéria e nível de ensino.
        </span>
      </div>
    </div>
  );
}
